import { useCallback } from 'react';
export const useHandleElementClick = _ref => {
  let {
    isOpen,
    toggleElement,
    onOpenElement
  } = _ref;
  const handleClickElement = useCallback(() => {
    if (!isOpen) {
      onOpenElement();
    }
    toggleElement();
  }, [isOpen, onOpenElement, toggleElement]);
  return {
    handleClickElement
  };
};
//# sourceMappingURL=use-handle-element-click.js.map